import { BsArrowRepeat } from "react-icons/bs";

function Waiting() {
  return (
    <>
      <header>
        <div className="relative min-h-screen overflow-hidden bg-center bg-cover">
          <div className="absolute top-0 bottom-0 left-0 right-0 w-full h-full overflow-hidden bg-fixed">
            <div className="flex items-center justify-center h-full">
              <div className="px-6 text-center text-white md:px-12">
                <h1 className="flex flex-row gap-6 mt-0 mb-6 text-4xl text-blue-700">
                  <span className="text-blue-700">Loading </span>
                  <BsArrowRepeat className="mt-1 mr-2 animate-spin" />
                </h1>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
export default Waiting;
